import React, { Component } from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
// core components
import Select from "react-select";
import Card from "@material-ui/core/Card";
import ImageUpload from "../../../components/CustomUpload/ImageUpload.jsx";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import TextField from "@material-ui/core/TextField";
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import {
  FormControl,
  // Input,
  // MenuItem,
  InputLabel,
  Tooltip,
  Switch,
} from "@material-ui/core";
// import InputLabel from "@material-ui/core/InputLabel";
import GridItem from "components/Grid/GridItem.jsx";
import SimpleReactValidator from "simple-react-validator";

import toastr from "toastr";
import { hist } from "../../..";

import axios from "../../../config/axios";
import { getAllCategories$ } from "../../../redux/actions/category.js";
import { getAllSpeakers$ } from "../../../redux/actions/speaker.js";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import moment from "moment";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  EditorState,
  // ContentState,
  // convertFromHTML,
  // convertToRaw
} from "draft-js";
// import draftToHtml from "draftjs-to-html";
import loaderIcon from "assets/img/loader.gif";
import { Fragment } from "react";

toastr.options = {
  closeButton: true,
};

const validationStyle = {
  color: "red",
};

const addButtonProps = {
  color: "rose",
  round: true,
};
const changeButtonProps = {
  color: "rose",
  round: true,
};
const removeButtonProps = {
  color: "danger",
  round: true,
};
// const formStyle = {
//   minWidth: 300,
//   margin: "0 1.2rem 1.2rem 0"
// };

/* Editor Component */
const modules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ font: [] }],
    ["bold", "italic", "underline", "strike"], // toggled buttons
    [{ align: [] }],
    [{ color: [] }, { background: [] }],
    ["image"],
    //['link', 'image', 'video'],
    //[{ 'header': 1 }, { 'header': 2 }],               // custom button values
    [{ script: "sub" }, { script: "super" }], // superscript/subscript
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
    ["blockquote", "code-block"],
    //[{ 'direction': 'rtl' }],                         // text direction
    //[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
    ["clean"], // remove formatting button
  ],
};
class AddEvent extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
    this.state = {
      action: "add",
      categoryList: [],
      name: "",
      event_images: null,
      category_name: [],
      speakerList: [],
      speaker_name: [],
      location: null,
      start_date: null,
      start_time: null,
      end_date: null,
      price: null,
      brief_desc: null,
      editorState: EditorState.createEmpty(),
      total_tickets: null,
      date: new Date().getTime(),
      eventType: [
        {
          value: "Free",
          label: "Free",
        },
        {
          value: "Paid",
          label: "Paid",
        },
      ],
      event_type: "",
      total_seats: "",
      waiting_seats: "",
      vip_seats:"",
      cancelled: false,
      sms: false,
      push: false,
      editableFields: false,
      survey_id: "",
      loading: false,
      group_booking_price: null,
      student_price: null,
      normal_price: null,
      early_bird_price: null,
      expiry_date: null,
      expiry_time: null,
    };
  }

  componentDidMount() {
    this.props.handleGetCategoryList();
    this.props.handleGetSpeakerList();
    if (this.props.location.state) {
      const { action, event } = this.props.location.state;
      if (action === "edit") {
        let {
          name,
          start_date,
          start_time,
          end_date,
          location,
          price,
          total_tickets,
          event_speaker,
          // speaker,
          event_category,
          event_images,
          brief_desc,
          editor,
          is_cancelled,
          share_sms,
          share_push,
          event_type,
          actual_seats,
          waiting_seats,
          vip_seats,
          booked_tickets,
          survey_hash,
          group_booking_price,
          student_price,
          normal_price,
          early_bird_price,
          expiry_date,
        } = event;

        let maxdate = moment(start_date).add("days", 1);
        let speaker_name = [];
        for (let i = 0; i < event_speaker.length; i++) {
          speaker_name.push({
            value: event_speaker[i].speaker.id,
            label: event_speaker[i].speaker.name,
          });
        }

        let category_name = [];
        // const speaker_name = { value: speaker.id, label: speaker.name };

        const image = event_images.length > 0 ? event_images[0].path : null;
        for (let i = 0; i < event_category.length; i++) {
          category_name.push({
            value: event_category[i].name,
            label: event_category[i].name,
          });
        }
        if (action === "edit" && booked_tickets > 0) {
          this.setState({
            editableFields: true,
          });
        }
        this.setState(
          {
            action,
            name,
            start_date: moment(new Date(start_date), "LLL"),
            end_date: moment(new Date(end_date), "LLL"),
            start_time: moment(new Date(start_time), "LLL"),
            location,
            price,
            total_tickets,
            speaker_name,
            category_name,
            brief_desc,
            event_images: image,
            editorState: editor ? editor : null,
            sms: share_sms,
            push: share_push,
            cancelled: is_cancelled,
            event_type: {
              value: event_type,
              label: event_type,
            },
            total_seats: actual_seats,
            waiting_seats,
            vip_seats,
            setMaxDate: maxdate,
            survey_id: survey_hash,
            group_booking_price: group_booking_price
              ? group_booking_price
              : null,
            student_price: student_price ? student_price : null,
            normal_price: normal_price ? normal_price : null,
            early_bird_price: early_bird_price ? early_bird_price : null,
            expiry_date: expiry_date
              ? moment(new Date(expiry_date), "LLL")
              : null,
          },
          () => console.log(this.state)
        );
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.categoryListData !== prevProps.categoryListData) {
      let categoryList = [];

      this.props.categoryListData &&
        this.props.categoryListData.data.length > 0 &&
        this.props.categoryListData.data.map((category) =>
          categoryList.push({ value: category.name, label: category.name })
        );
      this.setState({
        categoryList,
      });
    }
    if (this.props.speakerListData !== prevProps.speakerListData) {
      let speakerList = [];
      this.props.speakerListData &&
        this.props.speakerListData.data.length > 0 &&
        this.props.speakerListData.data.map((speaker) =>
          speakerList.push({ value: speaker.id, label: speaker.name })
        );
      this.setState({
        speakerList,
      });
    }
  }

  inputHandler = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  submitForm = () => {
    const {
      action,
      name,
      event_images,
      location,
      category_name,
      speaker_name,
      start_date,
      start_time,
      end_date,
      price,
      brief_desc,
      editorState,
      total_tickets,
      event_type,
      total_seats,
      waiting_seats,
      vip_seats,
      cancelled,
      sms,
      push,
      // setMaxDate,
      survey_id,
      group_booking_price,
      student_price,
      normal_price,
      early_bird_price,
      expiry_time,
      expiry_date,
    } = this.state;

    let event_category = [];
    for (let i = 0; i < category_name.length; i++) {
      let categoryObj = { name: category_name[i].value };
      event_category.push(categoryObj);
    }

    let speaker_category = [];
    for (let i = 0; i < speaker_name.length; i++) {
      let speakerObj = { speaker_id: speaker_name[i].value };
      speaker_category.push(speakerObj);
    }
    // let abc = date.format();
    //                   abc = new Date(abc).getTime();
    const startDate = start_date && start_date.format();
    const startDate_timestamp = new Date(startDate).getTime();

    // const endDate = new Date(endDate + "");
    // const endDate = end_date && end_date.format();
    const endDate_timestamp = new Date(end_date).getTime();

    //const endDate_timestamp = end_date.unix();
    // const speaker = { id: speaker_name && speaker_name.value };
    const image = [{ path: event_images }];
    // const editor = encodeURIComponent(
    //   draftToHtml(convertToRaw(editorState.getCurrentContent()))
    // );
    const editor = editorState;
    const requestBody = {
      name,
      start_time,
      start_date: startDate_timestamp,
      end_date: endDate_timestamp,
      location,
      price,
      total_tickets,
      event_speaker: speaker_category,
      event_images: image,
      brief_desc,
      event_category,
      editor,
      event_type: event_type.value,
      actual_seats: total_seats,
      waiting_seats,
      vip_seats,
      is_cancelled: cancelled,
      shareSms: sms,
      sharePush: push,
      survey_hash: survey_id,
      group_booking_price,
      student_price,
      normal_price,
      early_bird_price,
      expiry_date: expiry_time ? expiry_time : expiry_date,
    };

    console.log("in else");
    if (requestBody.start_date === requestBody.end_date) {
      toastr.error(
        "End date time cannot be same, less than or equal to start date time for same date."
      );
    } else {
      this.setState({ loading: true });
      if (this.validator.allValid()) {
        if (action === "add") {
          axios
            .post("events", requestBody)
            .then((res) => {
              if (res.status === 200 || res.status === 201) {
                toastr.success("Event Created Successfully!");
                setTimeout(() => hist.goBack(), 1000);
              }
            })
            .catch((error) => {
              this.setState({ loading: false });
              toastr.error(error.response.data.message);
            });
        } else {
          console.log("inside else");
          axios
            .put(`events/${this.props.location.state.event.id}`, requestBody)
            .then((res) => {
              if (res.status === 200) {
                toastr.success("Event Updated Successfully!");
                setTimeout(() => hist.goBack(), 1000);
              }
            })
            .catch((error) => {
              this.setState({ loading: false });
              toastr.error(error.response.data.message);
            });
        }
      } else {
        this.setState({ loading: false });
        this.validator.showMessages();
        this.forceUpdate();
      }
    }
  };

  fileUploadHandler = (file) => {
    let form = new FormData();
    form.append("image", file);
    axios
      .post("storage/event/upload-file", form)
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          this.setState({ event_images: res.data.data[0] });
        }
      })
      .catch((error) => {
        toastr.error(error.response.data.message);
      });
  };

  uploadImageCallBack = (file) => {
    return new Promise((resolve, reject) => {
      let form = new FormData();
      form.append("image", file);
      axios
        .post("storage/event/upload-file", form)
        .then((res) => {
          console.log(res.data.data[0]);
          console.log(typeof res.data.data[0]);
          if (res.status === 200 || res.status === 201) {
            resolve({ data: { link: res.data.data[0] } });
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  render() {
    // const { classes } = this.props;

    const {
      name,
      event_images,
      location,
      category_name,
      categoryList,
      speakerList,
      speaker_name,
      start_date,
      end_date,
      price,
      brief_desc,
      editorState,
      // total_tickets,
      eventType,
      event_type,
      total_seats,
      waiting_seats,
      vip_seats,
      cancelled,
      // sms,
      // push,
      editableFields,
      setMaxDate,
      survey_id,
      // action,
      loading,
      group_booking_price,
      student_price,
      normal_price,
      early_bird_price,
      expiry_date,
    } = this.state;
    // var today = new Date().toISOString();
    // var todayDate = today.substring(0, today.length - 8);
    console.log("this", survey_id);
    return (
      <div className="add-category-form">
        <Card
          // className={classes.card}
          style={{ overflow: "-webkit-paged-x" }}
        >
          {loading ? (
            <div className="loader_icon">
              <img src={loaderIcon} alt="loader" />
            </div>
          ) : (
            <React.Fragment>
              <CardContent>
                <form>
                  <GridContainer>
                    <GridItem md={12}>
                      <TextField
                        autoFocus
                        margin="dense"
                        id="survey_id"
                        name="survey_id"
                        label="Survey Id*"
                        type="text"
                        fullWidth
                        value={survey_id}
                        onChange={(event) => {
                          this.inputHandler(event);
                        }}
                      />
                    </GridItem>
                    <GridItem md={12}>
                      <FormControl
                        // className={classes.formControl}
                        fullWidth
                        style={{ margin: "0.7rem 0" }}
                      >
                        <legend style={{ fontSize: "1rem" }}>Event Type</legend>
                        <Select
                          name="event_type"
                          options={eventType}
                          value={event_type}
                          onChange={(inputValue, actionMeta) => {
                            if (inputValue) {
                              this.setState({
                                event_type: inputValue,
                              });
                            }
                          }}
                          className="basic-multi-select"
                          classNamePrefix="select"
                        />
                      </FormControl>
                      {
                        <span style={validationStyle}>
                          {this.validator.message(
                            "event_type",
                            event_type,
                            "required"
                          )}
                        </span>
                      }
                    </GridItem>
                    <GridItem md={12}>
                      <TextField
                        autoFocus
                        margin="dense"
                        id="event_name"
                        name="name"
                        label="Event Name*"
                        type="text"
                        fullWidth
                        value={name}
                        onChange={(event) => {
                          this.inputHandler(event);
                        }}
                      />
                      {
                        <span style={validationStyle}>
                          {this.validator.message(
                            "Event Name",
                            name,
                            "required"
                          )}
                        </span>
                      }
                    </GridItem>

                    <GridItem
                      md={12}
                      container
                      direction="column"
                      justify="center"
                      alignItems="center"
                      style={{ marginTop: "20px" }}
                    >
                      <legend>Banner Image</legend>
                      <ImageUpload
                        className="image_upload"
                        currentProduct={
                          event_images !== null
                            ? { image: event_images }
                            : { image: "" }
                        }
                        size="700*465"
                        uploadImage={this.fileUploadHandler}
                        addButtonProps={addButtonProps}
                        changeButtonProps={changeButtonProps}
                        removeButtonProps={removeButtonProps}
                      />
                      {
                        <span style={validationStyle}>
                          {this.validator.message(
                            "Banner Image",
                            event_images,
                            "required"
                          )}
                        </span>
                      }
                      <span>
                        Please upload image with 700 x 465 resolution having
                        JPEG, PNG, JPG format and Max size is 2mb
                      </span>
                    </GridItem>

                    <GridItem md={12}>
                      <TextField
                        InputLabelProps={{
                          shrink: location ? true : false,
                        }}
                        margin="dense"
                        id="location"
                        name="location"
                        label="Venue*"
                        type="text"
                        fullWidth
                        value={location}
                        onChange={(event) => {
                          this.inputHandler(event);
                        }}
                      />
                      {
                        <span style={validationStyle}>
                          {this.validator.message(
                            "Venue",
                            location,
                            "required"
                          )}
                        </span>
                      }
                    </GridItem>

                    <GridItem md={12}>
                      <FormControl
                        // className={classes.formControl}
                        fullWidth
                        style={{ margin: "0.7rem 0" }}
                      >
                        <legend style={{ fontSize: "1rem" }}>Category</legend>
                        <Select
                          isMulti
                          name="category"
                          options={categoryList}
                          value={category_name}
                          onChange={(inputValue, actionMeta) => {
                            if (inputValue) {
                              this.setState({
                                category_name: inputValue,
                              });
                            }
                          }}
                          className="basic-multi-select"
                          classNamePrefix="select"
                        />
                      </FormControl>
                      {
                        <span style={validationStyle}>
                          {this.validator.message(
                            "category_name",
                            category_name,
                            "required"
                          )}
                        </span>
                      }
                    </GridItem>

                    <GridItem className="date_text" md={6}>
                      <InputLabel shrink={true}>
                        Start Date &amp; Time
                      </InputLabel>
                      {/* <Input
                    name="start_date"
                    type="datetime-local"
                    value={start_date}
                    min={subDays}
                    onChange={event=> {
                      const { name, value } = event.target;
                      console.log(value);
                      this.setState({
                        [name]: value
                      });
                    }}
                  /> */}
                      <DatePicker
                        selected={start_date}
                        showTimeSelect={true}
                        dateFormat="LLL"
                        timeIntervals={15}
                        onChange={(date) => {
                          console.log(new Date(date).getTime());
                          let maxdate = moment(date).add("days", 1);
                          let toISOString = date.toISOString();
                          if (
                            new Date(date).getDate() === new Date().getDate() &&
                            new Date(date).getMonth() ===
                              new Date().getMonth() &&
                            new Date(date).getFullYear() ===
                              new Date().getFullYear()
                          ) {
                            if (
                              moment(new Date(date)).hour() * 60 +
                                moment(new Date(date)).minute() >=
                              moment(new Date()).hour() * 60 +
                                moment(new Date()).minute()
                            ) {
                              this.setState({
                                start_date: date,
                                setMaxDate: maxdate,
                                start_time: toISOString,
                              });
                            } else {
                              this.setState({ start_date: null });
                              toastr.error("Cant select past time.");
                            }
                          } else {
                            this.setState({
                              start_date: date,
                              setMaxDate: maxdate,
                              end_date: date,
                              start_time: toISOString,
                            });
                          }
                        }}
                        minDate={new Date()}
                        placeholderText="Select Start Date"
                      />
                      {
                        <span style={validationStyle}>
                          {this.validator.message(
                            "start_date",
                            start_date,
                            "required"
                          )}
                        </span>
                      }
                    </GridItem>

                    <GridItem className="date_text" md={6}>
                      <InputLabel shrink={true}>End Date &amp; Time</InputLabel>
                      <DatePicker
                        selected={end_date}
                        timeIntervals={15}
                        onChange={(date) => {
                          if (
                            new Date(date).getDate() ===
                            new Date(start_date).getDate()
                          ) {
                            if (
                              moment(new Date(date)).hour() * 60 +
                                moment(new Date(date)).minute() >
                              moment(new Date(start_date)).hour() * 60 +
                                moment(new Date(start_date)).minute()
                            ) {
                              this.setState({
                                end_date: date,
                              });
                            } else {
                              this.setState({ end_date: start_date });
                              toastr.error(
                                "End date time cannot be same, less than or equal to start date time for same date."
                              );
                            }
                          } else {
                            this.setState({
                              end_date: date,
                            });
                          }
                        }}
                        disabled={!start_date}
                        showTimeSelect={true}
                        dateFormat="LLL"
                        maxDate={setMaxDate}
                        minDate={
                          start_date !== null
                            ? start_date
                            : new Date(this.state.start_date)
                        }
                        placeholderText="Select End Date"
                      />
                      {
                        <span style={validationStyle}>
                          {this.validator.message(
                            "end_date",
                            end_date,
                            "required"
                          )}
                        </span>
                      }
                    </GridItem>

                    <GridItem className="brief_des" md={12}>
                      <TextField
                        InputLabelProps={{
                          shrink: brief_desc ? true : false,
                        }}
                        margin="dense"
                        id="brief_desc"
                        name="brief_desc"
                        label="Brief Description*"
                        type="text"
                        multiline={true}
                        fullWidth
                        value={brief_desc}
                        onChange={(event) => {
                          this.inputHandler(event);
                        }}
                      />
                      {
                        <span style={validationStyle}>
                          {this.validator.message(
                            "brief_desc",
                            brief_desc,
                            "required"
                          )}
                        </span>
                      }
                    </GridItem>

                    <GridItem md={12}>
                      <InputLabel shrink={true}>
                        Complete Description
                      </InputLabel>

                      <ReactQuill
                        onChange={(newValue, delta, source) => {
                          // console.log("onChange newValue:::: ", newValue, delta)
                          this.setState({ editorState: newValue });
                        }}
                        onBlur={(range, source, quill) => {
                          //console.log("onBlur quill.getHTML():::: ", quill.getHTML(), range, source,quill, quill.getLength(), quill.getText())
                          console.log(quill.getHTML());
                        }}
                        modules={modules}
                        theme="snow"
                        value={editorState}
                      />
                      <p>
                        *Please upload the images only in 692px x 400px
                        resolution
                      </p>
                    </GridItem>

                    <GridItem md={12}>
                      <FormControl
                        // className={classes.formControl}
                        fullWidth
                        style={{ margin: "0.7rem 0" }}
                      >
                        <legend style={{ fontSize: "1rem" }}>Speaker</legend>
                        <Select
                          isMulti
                          name="speaker"
                          options={speakerList}
                          value={speaker_name}
                          onChange={(inputValue, actionMeta) => {
                            if (inputValue) {
                              this.setState({
                                speaker_name: inputValue,
                              });
                            }
                          }}
                          className="basic-multi-select"
                          classNamePrefix="select"
                        />
                      </FormControl>
                      {
                        <span style={validationStyle}>
                          {this.validator.message(
                            "speaker_name",
                            speaker_name,
                            "required"
                          )}
                        </span>
                      }
                    </GridItem>

                    {event_type.value === "Paid" ? (
                      <div className="total_price_main">
                        {editableFields ? (
                          <Fragment>
                            <GridItem md={12}>
                              <TextField
                                InputLabelProps={{
                                  shrink: group_booking_price ? true : false,
                                }}
                                margin="dense"
                                id="price"
                                name="price"
                                label="Group Booking Price*"
                                type="number"
                                fullWidth
                                // disabled
                                value={group_booking_price}
                                onChange={(event) => {
                                  this.inputHandler(event);
                                }}
                              />
                              {
                                <span style={validationStyle}>
                                  {this.validator.message(
                                    "Group Booking Price",
                                    group_booking_price,
                                    "required"
                                  )}
                                </span>
                              }
                            </GridItem>
                            {/* <GridItem md={12}>
                                    <TextField
                                      InputLabelProps={{
                                        shrink: price ? true : false
                                      }}
                                      margin="dense"
                                      id="price"
                                      name="price"
                                      label="Price*"
                                      type="text"
                                      fullWidth

                                      value={price}
                                      onChange={event => {
                                        this.inputHandler(event);
                                      }}
                                    />
                                    {
                                      <span style={validationStyle}>
                                        {this.validator.message(
                                          "Group Booking Price",
                                          price,
                                          "required"
                                        )}
                                      </span>
                                    }
                            </GridItem> */}

                            <GridItem md={12}>
                              <TextField
                                InputLabelProps={{
                                  shrink: group_booking_price ? true : false,
                                }}
                                margin="dense"
                                id="group_booking_price"
                                name="group_booking_price"
                                label="Group Booking Price*"
                                type="number"
                                fullWidth
                                value={group_booking_price}
                                onChange={(event) => {
                                  this.inputHandler(event);
                                }}
                              />
                              {
                                <span style={validationStyle}>
                                  {this.validator.message(
                                    "Group Booking Price",
                                    group_booking_price,
                                    "required"
                                  )}
                                </span>
                              }
                            </GridItem>
                            <GridItem md={12}>
                              <TextField
                                InputLabelProps={{
                                  shrink: student_price ? true : false,
                                }}
                                margin="dense"
                                id="student_price"
                                name="student_price"
                                label="Student Price*"
                                type="number"
                                fullWidth
                                value={student_price}
                                onChange={(event) => {
                                  this.inputHandler(event);
                                }}
                              />
                              {
                                <span style={validationStyle}>
                                  {this.validator.message(
                                    "Student Price",
                                    student_price,
                                    "required"
                                  )}
                                </span>
                              }
                            </GridItem>
                            <GridItem md={12}>
                              <TextField
                                InputLabelProps={{
                                  shrink: normal_price ? true : false,
                                }}
                                margin="dense"
                                id="normal_price"
                                name="normal_price"
                                label="Normal Price*"
                                type="number"
                                fullWidth
                                value={normal_price}
                                onChange={(event) => {
                                  this.inputHandler(event);
                                }}
                              />
                              {
                                <span style={validationStyle}>
                                  {this.validator.message(
                                    "Normal Price",
                                    normal_price,
                                    "required"
                                  )}
                                </span>
                              }
                            </GridItem>
                            <div className="two_cols">
                              <GridItem md={3}>
                                <TextField
                                  InputLabelProps={{
                                    shrink: early_bird_price ? true : false,
                                  }}
                                  margin="dense"
                                  id="early_bird_price"
                                  name="early_bird_price"
                                  label="Early Bird Price*"
                                  type="number"
                                  fullWidth
                                  value={early_bird_price}
                                  onChange={(event) => {
                                    this.inputHandler(event);
                                  }}
                                />
                                {
                                  <span style={validationStyle}>
                                    {this.validator.message(
                                      "Early Bird Price",
                                      early_bird_price,
                                      "required"
                                    )}
                                  </span>
                                }
                              </GridItem>
                              <GridItem className="date_text" md={6}>
                                <InputLabel shrink={true}>
                                  Early Bird Expiry Date &amp; Time
                                </InputLabel>
                                <DatePicker
                                  selected={expiry_date}
                                  onChange={(date) => {
                                    let toISOString = date.toISOString();
                                    this.setState({
                                      expiry_time: toISOString,
                                      expiry_date: date,
                                    });
                                  }}
                                  showTimeSelect={true}
                                  dateFormat="LLL"
                                  // maxDate={setMaxDate}
                                  timeIntervals={15}
                                  minDate={new Date()}
                                  placeholderText="Select Date"
                                />

                                {
                                  <span style={validationStyle}>
                                    {this.validator.message(
                                      "expiry_date",
                                      expiry_date,
                                      "required"
                                    )}
                                  </span>
                                }
                              </GridItem>
                            </div>
                          </Fragment>
                        ) : (
                          <Fragment>
                            {price ? (
                              <GridItem md={12}>
                                <TextField
                                  InputLabelProps={{
                                    shrink: price ? true : false,
                                  }}
                                  margin="dense"
                                  id="price"
                                  name="price"
                                  label="Price*"
                                  type="text"
                                  fullWidth
                                  value={price}
                                  onChange={(event) => {
                                    this.inputHandler(event);
                                  }}
                                />
                                {
                                  <span style={validationStyle}>
                                    {this.validator.message(
                                      "Group Booking Price",
                                      price,
                                      "required"
                                    )}
                                  </span>
                                }
                              </GridItem>
                            ) : (
                              <Fragment>
                                                                <div className="two_cols">
                                  <GridItem md={3}>
                                    <TextField
                                      InputLabelProps={{
                                        shrink: early_bird_price ? true : false,
                                      }}
                                      margin="dense"
                                      id="early_bird_price"
                                      name="early_bird_price"
                                      label="Early Bird Price*"
                                      type="number"
                                      fullWidth
                                      value={early_bird_price}
                                      onChange={(event) => {
                                        this.inputHandler(event);
                                      }}
                                    />
                                    {
                                      <span style={validationStyle}>
                                        {this.validator.message(
                                          "Early Bird Price",
                                          early_bird_price,
                                          "required"
                                        )}
                                      </span>
                                    }
                                  </GridItem>
                                  <GridItem className="date_text" md={6}>
                                    <InputLabel shrink={true}>
                                      Early Bird Expiry Date &amp; Time
                                    </InputLabel>
                                    <DatePicker
                                      selected={expiry_date}
                                      onChange={(date) => {
                                        let toISOString = date.toISOString();
                                        this.setState({
                                          expiry_time: toISOString,
                                          expiry_date: date,
                                        });
                                      }}
                                      showTimeSelect={true}
                                      dateFormat="LLL"
                                      // maxDate={setMaxDate}
                                      timeIntervals={15}
                                      minDate={new Date()}
                                      placeholderText="Select Date"
                                    />

                                    {
                                      <span style={validationStyle}>
                                        {this.validator.message(
                                          "expiry_date",
                                          expiry_date,
                                          "required"
                                        )}
                                      </span>
                                    }
                                  </GridItem>
                                </div>

                                <GridItem md={12}>
                                  <TextField
                                    InputLabelProps={{
                                      shrink: student_price ? true : false,
                                    }}
                                    margin="dense"
                                    id="student_price"
                                    name="student_price"
                                    label="Student Price*"
                                    type="number"
                                    fullWidth
                                    value={student_price}
                                    onChange={(event) => {
                                      this.inputHandler(event);
                                    }}
                                  />
                                  {
                                    <span style={validationStyle}>
                                      {this.validator.message(
                                        "Student Price",
                                        student_price,
                                        "required"
                                      )}
                                    </span>
                                  }
                                </GridItem>
                                <GridItem md={12}>
                                  <TextField
                                    InputLabelProps={{
                                      shrink: normal_price ? true : false,
                                    }}
                                    margin="dense"
                                    id="normal_price"
                                    name="normal_price"
                                    label="Normal Price*"
                                    type="number"
                                    fullWidth
                                    value={normal_price}
                                    onChange={(event) => {
                                      this.inputHandler(event);
                                    }}
                                  />
                                  {
                                    <span style={validationStyle}>
                                      {this.validator.message(
                                        "Normal Price",
                                        normal_price,
                                        "required"
                                      )}
                                    </span>
                                  }
                                </GridItem>
                                <GridItem md={12}>
                                  <TextField
                                    InputLabelProps={{
                                      shrink: group_booking_price
                                        ? true
                                        : false,
                                    }}
                                    margin="dense"
                                    id="group_booking_price"
                                    name="group_booking_price"
                                    label="Group Booking Price*"
                                    type="number"
                                    fullWidth
                                    value={group_booking_price}
                                    onChange={(event) => {
                                      this.inputHandler(event);
                                    }}
                                  />
                                  {
                                    <span style={validationStyle}>
                                      {this.validator.message(
                                        "Group Booking Price",
                                        group_booking_price,
                                        "required"
                                      )}
                                    </span>
                                  }
                                </GridItem>
                              </Fragment>
                            )}
                          </Fragment>
                        )}
                      </div>
                    ) : null}
                    {this.state.action === "add" ? (
                      <GridItem md={12}>
                        <TextField
                          InputLabelProps={{
                            shrink: total_seats >= 0 ? true : false,
                          }}
                          margin="dense"
                          id="total_seats"
                          name="total_seats"
                          label="Actual seats in the event*"
                          type="number"
                          fullWidth
                          value={total_seats}
                          onChange={(event) => {
                            this.inputHandler(event);
                          }}
                        />
                        {
                          <span style={validationStyle}>
                            {this.validator.message(
                              "total_seats",
                              total_seats,
                              "required"
                            )}
                          </span>
                        }
                      </GridItem>
                    ) : (
                      <GridItem md={12}>
                        <TextField
                          InputLabelProps={{
                            shrink: total_seats >= 0 ? true : false,
                          }}
                          margin="dense"
                          id="total_seats"
                          name="total_seats"
                          label="Actual seats in the event*"
                          type="number"
                          fullWidth
                          value={total_seats}
                          disabled
                          onChange={(event) => {
                            this.inputHandler(event);
                          }}
                        />
                        {
                          <span style={validationStyle}>
                            {this.validator.message(
                              "total_seats",
                              total_seats,
                              "required"
                            )}
                          </span>
                        }
                      </GridItem>
                    )}

                    <GridItem md={12}>
                      <TextField
                        InputLabelProps={{
                          shrink: vip_seats ? true : false,
                        }}
                        margin="dense"
                        id="vip_seats"
                        name="vip_seats"
                        label="Reserved Seats for VIP*"
                        type="number"
                        multiline={true}
                        fullWidth
                        // value={vip_seats}
                        onChange={(event) => {
                          this.inputHandler(event);
                        }}
                      />
                      {
                        <span style={validationStyle}>
                          {this.validator.message(
                            "vip_seats",
                            vip_seats,
                            "required"
                          )}
                        </span>
                      }
                    </GridItem>

                    <GridItem md={12}>
                      <TextField
                        InputLabelProps={{
                          shrink: waiting_seats ? true : false,
                        }}
                        margin="dense"
                        id="waiting_seats"
                        name="waiting_seats"
                        label="No. of seats available in waiting*"
                        type="number"
                        multiline={true}
                        fullWidth
                        value={waiting_seats}
                        onChange={(event) => {
                          this.inputHandler(event);
                        }}
                      />
                      {
                        <span style={validationStyle}>
                          {this.validator.message(
                            "waiting_seats",
                            waiting_seats,
                            "required"
                          )}
                        </span>
                      }
                    </GridItem>
                    {/* <GridItem md={12}>
                  <TextField
                    InputLabelProps={{
                      shrink: total_tickets ? true : false
                    }}
                    margin="dense"
                    id="total_tickets"
                    name="total_tickets"
                    label="No. of tickets to be sold*"
                    type="text"
                    multiline={true}
                    fullWidth
                    value={total_tickets}
                    onChange={event=> {
                      this.inputHandler(event);
                    }}
                  />
                  {
                    <span style={validationStyle}>
                      {this.validator.message(
                        "total_tickets",
                        total_tickets,
                        "required"
                      )}
                    </span>
                  }
                </GridItem> */}
                    {/* <GridItem>
                        <span>Can be Cancelled</span>
                        <Tooltip title="Toggle Status">
                          <Switch
                            color="primary"
                            checked={
                              cancelled
                              // this.state.ProductList[serial_number.index].is_active
                            }
                            onClick={e => {
                              e.stopPropagation();
                              this.setState({
                                cancelled: !cancelled
                              });
                            }}
                          />
                        </Tooltip>
                      </GridItem> */}
                    {/* <GridItem>
                      <span>Share update to the user via SMS</span>
                      <Tooltip title="Toggle Status">
                        <Switch
                          checked={
                            sms
                            // this.state.ProductList[serial_number.index].is_active
                          }
                          onClick={e => {
                            e.stopPropagation();
                            this.setState({
                              sms: !sms
                            });
                          }}
                        />
                      </Tooltip>
                    </GridItem>

                    <GridItem>
                      <span>Share update to the user via Push</span>
                      <Tooltip title="Toggle Status">
                        <Switch
                          checked={
                            push
                            // this.state.ProductList[serial_number.index].is_active
                          }
                          onClick={e => {
                            e.stopPropagation();
                            this.setState({
                              push: !push
                            });
                          }}
                        />
                      </Tooltip>
                    </GridItem> */}
                  </GridContainer>
                </form>
              </CardContent>
              <CardActions style={{ float: "right" }}>
                <Button
                  variant="contained"
                  color="iseas"
                  onClick={this.submitForm}
                >
                  Submit
                </Button>
              </CardActions>
            </React.Fragment>
          )}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    categoryListData: state.category,
    speakerListData: state.speaker,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleGetCategoryList: () => dispatch(getAllCategories$.trigger()),
    handleGetSpeakerList: () => dispatch(getAllSpeakers$.trigger()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(extendedFormsStyle)(AddEvent));



// WEBPACK FOOTER //
// ./src/views/ISEAS/EventManagement/AddEvent.js